import ApolloClient from 'apollo-boost';
import gql from 'graphql-tag';
import LocalStorage from './localstorage';
import { staticProperties, STATICKEYS } from '../components/common/staticProperties';
import { LOGGEDINUSERTYPE } from '../components/common/constants';
import Constants from '../components/common/constants';

const URL = 'https://staging.eye.guide/graphql';
const storage = new LocalStorage();
// const ERROR_AUTH = 'jwt expired';
// const ERROR_ACTIVE = 'no active';
// const ERROR_INVALID_TEST = 'invalid tests';
// const ERROR_NOT_FOUND = 'NOT FOUND';

const instance = new ApolloClient<{}>({
    uri: URL,
    request: async (operation) => {
        const token = storage.getToken();
        if (token.length > 0) {
            operation.setContext({
                headers: {
                    'x-authorization': 'Bearer ' + token,
                },
            });
        }
    },
});

export default class ApolloClientService {
    _instance: ApolloClient<{}>;

    constructor() {
        this._instance = instance;
    }

    public async getActivityCounts(input: any) {
        let data = await this._instance.query<{ activityCounts: Array<any> }>({
            query: gql`
                query activityCounts($input: FilterObj) {
                    activityCounts(input: $input) {
                        tests
                        logins
                        syncs
                        orgs
                    }
                }
            `,
            variables: {
                input,
            },
            fetchPolicy: 'no-cache',
        });
        console.log('login counts', data.data);
        return data.data
            ? data.data.activityCounts
            : { err: 'getting count failed, response not received' };
    }

    public async getChartData(limit: number, input: any) {
        let data = await this._instance.query<{ getChartData: Array<any> }>({
            query: gql`
                query getChartData($limit: Int, $input: FilterObj) {
                    getChartData(limit: $limit, input: $input) {
                        recorded_date
                        customers
                        organizations
                        baselines
                        tests
                        syncs
                        logins
                    }
                }
            `,
            variables: {
                limit,
                input,
            },
            fetchPolicy: 'no-cache',
        });
        console.log('chart data', data.data);
        return data.data
            ? data.data.getChartData
            : { err: 'getting data failed, response not received' };
    }

    public async getTestRecords(limit: any, input: any) {
        let data = await this._instance.query<{ testRecords: Array<any> }>({
            query: gql`
                query testRecords($limit: Int, $input: FilterObj) {
                    testRecords(limit: $limit, input: $input) {
                        customer
                        organization
                        username
                        firstname
                        lastname
                        testtype
                        testdate
                    }
                }
            `,
            variables: {
                limit,
                input,
            },
            fetchPolicy: 'no-cache',
        });
        console.log('test records', data.data);
        return data.data
            ? data.data.testRecords
            : { err: 'getting tests failed, response not received' };
    }

    public async getCreatedOrgs(limit: any, input: any) {
        let data = await this._instance.query<{ createdOrganizations: Array<any> }>({
            query: gql`
                query createdOrganizations($limit: Int, $input: FilterObj) {
                    createdOrganizations(limit: $limit, input: $input) {
                        customer
                        organization
                        createdat
                    }
                }
            `,
            variables: {
                limit,
                input,
            },
            fetchPolicy: 'no-cache',
        });
        console.log('organizations', data.data);
        return data.data
            ? data.data.createdOrganizations
            : { err: 'getting orgs failed, response not received' };
    }

    public async getActivityFeed(limit: number, lastid: any, input: any) {
        let data = await this._instance.query<{ activityFeed: Array<any> }>({
            query: gql`
                query activityFeed($limit: Int, $lastid: String, $input: FilterObj) {
                    activityFeed(limit: $limit, lastid: $lastid, input: $input) {
                        id
                        username
                        type
                        data
                        time
                        firstname
                        lastname
                        customer {
                            name
                            organizationid
                        }
                        roleid
                    }
                }
            `,
            variables: {
                limit,
                lastid,
                input,
            },
            fetchPolicy: 'no-cache',
        });
        console.log('activities', data.data);
        return data.data
            ? data.data.activityFeed
            : { err: 'getting activities failed, response not received' };
    }

    public async login(username: string, password: string) {
        let data = await this._instance.mutate({
            mutation: gql`
                mutation Login($username: String!, $password: String!) {
                    Login(username: $username, password: $password) {
                        token
                        err
                        uid
                        firstname
                        lastname
                        roleid
                        primaryorganizationname
                        showTC
                        templatename
                        version
                        zEWidgetToken
                        zESSOToken
                    }
                }
            `,
            variables: {
                username,
                password,
            },
        });
        return data.data ? data.data.Login : { err: 'login failed, response not received' };
    }

    public async generateZendeskToken(type: number) {
        try {
            let data = await this._instance.query<{ GenerateZendeskToken: any }>({
                query: gql`
                    query GenerateZendeskToken($type: Int!) {
                        GenerateZendeskToken(type: $type) {
                            token
                        }
                    }
                `,
                variables: {
                    type,
                },
                fetchPolicy: 'no-cache',
            });

            return data.data
                ? data.data.GenerateZendeskToken
                : { err: 'GenerateZendeskToken failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async updateLogoutTime() {
        let data = await this._instance.mutate({
            mutation: gql`
                mutation updateLogoutTime {
                    updateLogoutTime {
                        status
                        message
                    }
                }
            `,
        });
        return data.data ? data.data.updateLogoutTime : { err: 'failed, response not received' };
    }

    public async updateUserTC(encryptedToken: string, version: string, uid: string) {
        let data = await this._instance.mutate({
            mutation: gql`
                mutation updateUserTC($encryptedToken: String, $version: String, $uid: String) {
                    updateUserTC(encryptedToken: $encryptedToken, version: $version, uid: $uid) {
                        token
                    }
                }
            `,
            variables: {
                encryptedToken,
                version,
                uid,
            },
        });
        return data.data ? data.data.updateUserTC : { err: 'login failed, response not received' };
    }

    public async getTC(filename: string) {
        let data = await this._instance.query<{ getTC: any }>({
            query: gql`
                query getTC($filename: String!) {
                    getTC(filename: $filename) {
                        htmlcontent
                    }
                }
            `,
            variables: {
                filename,
            },
            fetchPolicy: 'no-cache',
        });
        return data.data ? data.data.getTC : { err: 'failed getting tc' };
    }

    public async getOrganizationsWithCounts() {
        try {
            let data = await this._instance.query<{ Organizations: Array<any> }>({
                query: gql`
                    query Organizations {
                        Organizations {
                            organizationid
                            name
                            totalAthletes
                            totalBaselinePending
                            totalImpairedTests
                            totalBaselines
                            totalTests
                            totalBaselinesThisWeek
                            rosterid
                            isprimary
                            primaryorganizationid
                        }
                    }
                `,
                fetchPolicy: 'no-cache',
            });
            console.log('getOrganizationsWithCounts');
            return data.data
                ? data.data.Organizations
                : { err: 'getting organizations failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getOrganizations() {
        try {
            let data = await this._instance.query<{ Organizations: Array<any> }>({
                query: gql`
                    query Organizations {
                        Organizations {
                            organizationid
                            name
                            rosterid
                            isprimary
                            primaryorganizationid
                            enableprivacy
                            enablefailedtestreport
                        }
                    }
                `,
                fetchPolicy: 'no-cache',
            });
            console.log('getOrganizations');
            return data.data
                ? data.data.Organizations
                : { err: 'getting organizations failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getProfiles(rosterid: string) {
        try {
            let data = await this._instance.query<{ athletes: Array<any> }>({
                query: gql`
                    query athletes($rosterid: String!) {
                        athletes(rosterid: $rosterid) {
                            playerid
                            firstname
                            lastname
                            concussed
                            organizationname
                            rosterid
                            playerinfo {
                                playerinfoname
                                playerinfovalue
                            }
                        }
                    }
                `,
                variables: {
                    rosterid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.athletes
                : { err: 'getting profiles failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getTestsByPrimaryOrgId(primaryorgid: string) {
        try {
            let data = await this._instance.query<{ testsByPrimaryOrgId: Array<any> }>({
                query: gql`
                    query testsByPrimaryOrgId($primaryorgid: String!) {
                        testsByPrimaryOrgId(primaryorgid: $primaryorgid) {
                            testid
                            playerid
                            testtimestamp
                            baseline
                            concussed
                            score
                            range
                            athlete {
                                firstname
                                lastname
                            }
                        }
                    }
                `,
                variables: {
                    primaryorgid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.testsByPrimaryOrgId
                : { err: 'getting tests failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async getTests(rosterid: string) {
        try {
            let data = await this._instance.query<{ Tests: Array<any> }>({
                query: gql`
                    query Tests($rosterid: String!) {
                        Tests(rosterid: $rosterid) {
                            testid
                            playerid
                            testtimestamp
                            baseline
                            concussed
                            score
                            range
                            testtag
                            athlete {
                                firstname
                                lastname
                                organizationname
                                playerinfo {
                                    playerinfoname
                                    playerinfovalue
                                }
                            }
                        }
                    }
                `,
                variables: {
                    rosterid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.Tests
                : { err: 'getting tests failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async getProfile(profileid: string) {
        try {
            let playerid = profileid;
            let data = await this._instance.query<{ athletesByPlayerId: Array<any> }>({
                query: gql`
                    query athletesByPlayerId($playerid: String!) {
                        athletesByPlayerId(playerid: $playerid) {
                            playerid
                            firstname
                            lastname
                            rosterid
                            concussed
                            organizationname
                            baseline
                            playerinfo {
                                playerinfoname
                                playerinfovalue
                            }
                            tests {
                                testid
                                playerid
                                testtimestamp
                                baseline
                                concussed
                                score
                                range
                                testtag
                                athlete {
                                    playerid
                                    firstname
                                    lastname
                                }
                                testinfo {
                                    testinfoname
                                    testinfovalue
                                }
                            }
                        }
                    }
                `,
                variables: {
                    playerid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.athletesByPlayerId
                : { err: 'getting athelete failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async addAthelete(input: any, rosterid: string) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation addAthlete($rosterid: String!, $input: PlayerInput!) {
                        addAthlete(rosterid: $rosterid, input: $input) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    rosterid,
                    input,
                },
            });
            return data.data
                ? data.data.addAthlete
                : { err: 'insert of athelete failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async updateAthelete(input: any, playerid: string) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation updateAthlete($input: PlayerInput!, $playerid: String!) {
                        updateAthlete(input: $input, playerid: $playerid) {
                            playerid
                            firstname
                            lastname
                            playerinfo {
                                playerinfoname
                                playerinfovalue
                            }
                        }
                    }
                `,
                variables: {
                    input,
                    playerid,
                },
            });
            return data.data
                ? data.data.addAthlete
                : { err: 'update on athelete failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getTestsOfAthlete(playerid: string) {
        try {
            let data = await this._instance.query<{ getTestsOfAthlete: Array<any> }>({
                query: gql`
                    query getTestsOfAthlete($playerid: String!) {
                        getTestsOfAthlete(playerid: $playerid) {
                            testid
                            playerid
                            testtimestamp
                            baseline
                            concussed
                            score
                            scoringversion
                            athlete {
                                playerid
                                firstname
                                lastname
                            }
                            range
                            err
                        }
                    }
                `,
                variables: {
                    playerid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.getTestsOfAthlete
                : { err: 'get on test failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getProfilesByTestDateRange(rosterid: any, daterange: any, primaryorgid: any) {
        try {
            let data = await this._instance.query<{ profilesByTestDateRange: Array<any> }>({
                query: gql`
                    query profilesByTestDateRange(
                        $rosterid: String
                        $daterange: [String]
                        $primaryorgid: String
                    ) {
                        profilesByTestDateRange(
                            rosterid: $rosterid
                            daterange: $daterange
                            primaryorgid: $primaryorgid
                        ) {
                            playerid
                            firstname
                            lastname
                            concussed
                            organizationname
                            rosterid
                            playerinfo {
                                playerinfoname
                                playerinfovalue
                            }
                            tests {
                                testid
                                testtimestamp
                            }
                        }
                    }
                `,
                variables: {
                    rosterid,
                    daterange,
                    primaryorgid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.profilesByTestDateRange
                : { err: 'get on test failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getTestsAfterLastBaseline(
        playerid: string,
        testtimestamp: string,
        daterange: any = []
    ) {
        try {
            let data = await this._instance.query<{ getTestsAfterLastBaseline: Array<any> }>({
                query: gql`
                    query getTestsAfterLastBaseline(
                        $playerid: String!
                        $testtimestamp: String!
                        $daterange: [String]
                    ) {
                        getTestsAfterLastBaseline(
                            playerid: $playerid
                            testtimestamp: $testtimestamp
                            daterange: $daterange
                        ) {
                            testid
                            playerid
                            testtimestamp
                            baseline
                            bestbaseline
                            concussed
                            score
                            scoringversion
                            testtag
                            athlete {
                                playerid
                                firstname
                                lastname
                            }
                            range
                            err
                        }
                    }
                `,
                variables: {
                    playerid,
                    testtimestamp,
                    daterange,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.getTestsAfterLastBaseline
                : { err: 'get on test failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getProfilesForDashboard(type: string, organizationid: any) {
        try {
            let data = await this._instance.query<{ getDashboardProfiles: Array<any> }>({
                query: gql`
                    query getDashboardProfiles($type: String!, $organizationid: String) {
                        getDashboardProfiles(type: $type, organizationid: $organizationid) {
                            playerid
                            firstname
                            lastname
                            concussed
                            organizationname
                            rosterid
                            playerinfo {
                                playerinfoname
                                playerinfovalue
                            }
                        }
                    }
                `,
                variables: {
                    type,
                    organizationid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.getDashboardProfiles
                : { err: 'getting profiles failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getUncheckedOrgs(uid: string) {
        try {
            let data = await this._instance.query<{ uncheckedOrganizations: Array<any> }>({
                query: gql`
                    query uncheckedOrganizations($uid: String) {
                        uncheckedOrganizations(uid: $uid) {
                            id
                            uid
                            primaryorganizationid
                            organizationid
                        }
                    }
                `,
                variables: {
                    uid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('subOrganizations', data.data.uncheckedOrganizations);
            return data.data
                ? data.data.uncheckedOrganizations
                : { err: 'getting subOrganizations failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getSubOrganizations(active: any, primaryorganizationid: string) {
        try {
            let data = await this._instance.query<{ subOrganizations: Array<any> }>({
                query: gql`
                    query subOrganizations($active: Int, $primaryorganizationid: String) {
                        subOrganizations(
                            active: $active
                            primaryorganizationid: $primaryorganizationid
                        ) {
                            organizationid
                            name
                            contactfirstname
                            contactlastname
                            jobtitle
                            contactphone
                            contactemail
                            address
                            country
                            state
                            city
                            pincode
                            email
                            website
                            isprimary
                            enablefailedtestreport
                            enablebestbaseline
                            testtags
                            rosterid
                            active
                            primaryorganizationid
                            totalAthletes
                            totalBaselinePending
                            totalImpairedTests
                            totalBaselines
                            totalTests
                            totalBaselinesThisWeek
                        }
                    }
                `,
                variables: {
                    active,
                    primaryorganizationid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('subOrganizations', data.data.subOrganizations);
            return data.data
                ? data.data.subOrganizations
                : { err: 'getting subOrganizations failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getOrganization(organizationid: any) {
        try {
            let data = await this._instance.query<{ organization: any }>({
                query: gql`
                    query organization($organizationid: String!) {
                        organization(organizationid: $organizationid) {
                            organizationid
                            name
                            contactfirstname
                            contactlastname
                            jobtitle
                            contactphone
                            contactemail
                            address
                            country
                            state
                            city
                            pincode
                            email
                            website
                            isprimary
                            rosterid
                            active
                            totalAthletes
                            totalBaselines
                            totalTests
                            testtags
                            enableprivacy
                            enablebestbaseline
                            enablefailedtestreport
                            viewinapptest
                            viewinappbaseline
                        }
                    }
                `,
                variables: {
                    organizationid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('getOrganization');
            return data.data
                ? data.data.organization
                : { err: 'getting organization failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getOrganizationWithUsers(organizationid: any) {
        try {
            let data = await this._instance.query<{ organization: any }>({
                query: gql`
                    query organization($organizationid: String!) {
                        organization(organizationid: $organizationid) {
                            organizationid
                            name
                            contactfirstname
                            contactlastname
                            jobtitle
                            contactphone
                            contactemail
                            address
                            country
                            state
                            city
                            pincode
                            email
                            website
                            isprimary
                            rosterid
                            active
                            users {
                                uid
                                username
                                firstname
                                lastname
                                email
                                roleid
                                active
                            }
                        }
                    }
                `,
                variables: {
                    organizationid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('getOrganization');
            return data.data
                ? data.data.organization
                : { err: 'getting organization failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async addSubOrganization(input: any, primaryorganizationid: string) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation addSubOrganization(
                        $input: OrganizationInput!
                        $primaryorganizationid: String
                    ) {
                        addSubOrganization(
                            input: $input
                            primaryorganizationid: $primaryorganizationid
                        ) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    input,
                    primaryorganizationid,
                },
            });
            return data.data
                ? data.data.addSubOrganization
                : { err: 'insert of athelete failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async updateSubOrganization(input: any, organizationid: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation editSubOrganization(
                        $input: OrganizationInput!
                        $organizationid: String!
                    ) {
                        editSubOrganization(input: $input, organizationid: $organizationid) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    input,
                    organizationid,
                },
            });
            return data.data
                ? data.data.editSubOrganization
                : { err: 'update  of athelete failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getUsers(active: any, primaryorganizationid: string) {
        try {
            let data = await this._instance.query<{ users: Array<any> }>({
                query: gql`
                    query users($active: Int!, $primaryorganizationid: String) {
                        users(active: $active, primaryorganizationid: $primaryorganizationid) {
                            uid
                            username
                            firstname
                            lastname
                            email
                            roleid
                            active
                            organizations {
                                organizationid
                                name
                            }
                            setup
                            signin
                        }
                    }
                `,
                variables: {
                    active,
                    primaryorganizationid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('users');
            return data.data
                ? data.data.users
                : { err: 'getting users failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async addeditUser(input: any, uid: any, primaryorgid: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation addeditUser($input: UserInput!, $uid: String, $primaryorgid: String) {
                        addeditUser(input: $input, uid: $uid, primaryorgid: $primaryorgid) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    input,
                    uid,
                    primaryorgid,
                },
            });
            return data.data
                ? data.data.addeditUser
                : { err: 'update of user failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getUser(uid: any) {
        try {
            let data = await this._instance.query<{ user: any }>({
                query: gql`
                    query user($uid: String!) {
                        user(uid: $uid) {
                            uid
                            username
                            firstname
                            lastname
                            email
                            active
                            roleid
                            phone
                            candeletetest
                            canaddprofile
                            organizations {
                                organizationid
                                name
                            }
                        }
                    }
                `,
                variables: {
                    uid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.user
                : { err: 'get of user failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async verifyUsername(username: string, token: string = '') {
        try {
            let data = await this._instance.query<{ verifyUsername: any }>({
                query: gql`
                    query verifyUsername($username: String!, $token: String) {
                        verifyUsername(username: $username, token: $token) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    username,
                    token,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.verifyUsername
                : { err: 'verify of user failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async verifyCustomerName(name: string) {
        try {
            let data = await this._instance.query<{ verifyCustomer: any }>({
                query: gql`
                    query verifyCustomer($name: String!) {
                        verifyCustomer(name: $name) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    name,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.verifyCustomer
                : { err: 'verify of Customer failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async resetPassword(uid: any, username: any, role: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation resetPassword($uid: String, $username: String, $role: String) {
                        resetPassword(uid: $uid, username: $username, role: $role) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    uid,
                    username,
                    role,
                },
            });
            return data.data
                ? data.data.resetPassword
                : { err: 'update of user failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getUserByShareId(userid: string, shareid: string, profileShare: number) {
        try {
            let data = await this._instance.query<{ userByShareId: any }>({
                query: gql`
                    query userByShareId($userid: String, $shareid: String, $profileShare: Int) {
                        userByShareId(
                            userid: $userid
                            shareid: $shareid
                            profileShare: $profileShare
                        ) {
                            email
                            phone
                        }
                    }
                `,
                variables: {
                    userid,
                    shareid,
                    profileShare,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.userByShareId
                : { err: 'create of share user failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async createShareTestForExport(input: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation createShareTestForExport($input: [ShareProfile]) {
                        createShareTestForExport(input: $input) {
                            organization
                            firstname
                            lastname
                            email
                            phone
                            middlename
                            level
                            gender
                            id
                            sport
                            birthdate
                            testids
                            shareLink
                        }
                    }
                `,
                variables: {
                    input,
                },
            });
            return data.data
                ? data.data.createShareTestForExport
                : { err: 'create of share test for export failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async createSharedTest(testid: any, returntoactivity: number, input: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation createShareTest(
                        $testid: [String]
                        $returntoactivity: Int
                        $input: [ShareUserInput]
                    ) {
                        createShareTest(
                            testid: $testid
                            returntoactivity: $returntoactivity
                            input: $input
                        ) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    testid,
                    returntoactivity,
                    input,
                },
            });
            return data.data
                ? data.data.createShareTest
                : { err: 'create of share test failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async generateOTP(shareuserid: string, shareid: string, phone: string, email: string) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation generateOTP(
                        $shareuserid: String
                        $shareid: String
                        $email: String
                        $phone: String
                    ) {
                        generateOTP(
                            shareuserid: $shareuserid
                            shareid: $shareid
                            phone: $phone
                            email: $email
                        ) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    shareuserid,
                    shareid,
                    phone,
                    email,
                },
            });
            return data.data
                ? data.data.generateOTP
                : { err: 'generate otp failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async externalLogin(shareuserid: string, shareid: string, phoneotp: string) {
        try {
            let data = await this._instance.query<{ externalLogin: any }>({
                query: gql`
                    query externalLogin($shareuserid: String, $shareid: String, $phoneotp: String) {
                        externalLogin(
                            shareuserid: $shareuserid
                            shareid: $shareid
                            phoneotp: $phoneotp
                        ) {
                            message
                            status
                            name
                            token
                        }
                    }
                `,
                variables: {
                    shareuserid,
                    shareid,
                    phoneotp,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.externalLogin
                : { err: 'verify of user failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getShares(shareuserid: string) {
        try {
            let data = await this._instance.query<{ shares: any }>({
                query: gql`
                    query shares($shareuserid: String) {
                        shares(shareuserid: $shareuserid) {
                            username
                            organization
                            time
                            shareid
                            returntoactivity
                        }
                    }
                `,
                variables: {
                    shareuserid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.shares
                : { err: 'getting shares failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getSharetests(shareid: string) {
        try {
            let data = await this._instance.query<{ sharetests: any }>({
                query: gql`
                    query sharetests($shareid: String) {
                        sharetests(shareid: $shareid) {
                            testid
                            playerid
                            testtimestamp
                            baseline
                            concussed
                            score
                            range
                            testtag
                            athlete {
                                firstname
                                lastname
                            }
                        }
                    }
                `,
                variables: {
                    shareid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.sharetests
                : { err: 'getting share tests failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async testDownloaded(testResult: string) {
        let data = await this._instance.mutate({
            mutation: gql`
                mutation testDownloaded($testResult: String) {
                    testDownloaded(testResult: $testResult) {
                        message
                        status
                    }
                }
            `,
            variables: {
                testResult,
            },
        });
        return data.data ? data.data : { err: 'response not received' };
    }

    public async getTestResults(testid: string, baseline: number) {
        try {
            let data = await this._instance.query<{ testResults: any }>({
                query: gql`
                    query testResults($testid: String, $baseline: Int) {
                        testResults(testid: $testid, baseline: $baseline) {
                            testid
                            playerid
                            testtimestamp
                            baseline
                            concussed
                            score
                            scoringversion
                            range
                            testtag
                            athlete {
                                firstname
                                lastname
                                organizationname
                                rosterid
                                playerinfo {
                                    playerinfoname
                                    playerinfovalue
                                }
                            }
                            err
                            testcoords {
                                testcoordid
                                testid
                                testcoordtimestamp
                                eye_x
                                eye_y
                            }
                            calibaratedtestcoords {
                                eye_x
                                eye_y
                            }
                            testinfo {
                                testinfoname
                                testinfovalue
                            }
                        }
                    }
                `,
                variables: {
                    testid,
                    baseline,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.testResults
                : { err: 'getting test coords failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getOrganizationByRoster(rosterid: string) {
        try {
            let data = await this._instance.query<{ organizationByRoster: any }>({
                query: gql`
                    query organizationByRoster($rosterid: String!) {
                        organizationByRoster(rosterid: $rosterid) {
                            name
                            organizationid
                            testtags
                        }
                    }
                `,
                variables: {
                    rosterid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('organizationByRoster');
            staticProperties.set(
                STATICKEYS.organizationId,
                data.data.organizationByRoster.organizationid
            );
            return data.data
                ? data.data.organizationByRoster
                : { err: 'getting organization failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async uploadProfiles(file: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation uploadProfiles($file: Upload!) {
                        uploadProfiles(file: $file) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    file,
                },
            });
            return data.data
                ? data.data.uploadProfiles
                : { err: 'update on athelete failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async contactAdmin() {
        try {
            let data = await this._instance.query<{ contactAdmin: any }>({
                query: gql`
                    query contactAdmin {
                        contactAdmin {
                            message
                            status
                        }
                    }
                `,
                fetchPolicy: 'no-cache',
            });
            console.log('contactAdmin');
            return data.data
                ? data.data.contactAdmin
                : { err: 'contacting admin failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async editTest(testid: any, input: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation editTest($testid: String!, $input: TestInput) {
                        editTest(testid: $testid, input: $input) {
                            message
                            status
                        }
                    }
                `,
                variables: {
                    testid,
                    input,
                },
            });
            return data.data
                ? data.data.editTest
                : { err: 'edit of test failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async validateLink(shareid: string) {
        try {
            let data = await this._instance.query<{ validateLink: any }>({
                query: gql`
                    query validateLink($shareid: String) {
                        validateLink(shareid: $shareid) {
                            message
                            status
                            firstname
                            lastname
                            organizationname
                        }
                    }
                `,
                variables: {
                    shareid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('validateLink');
            return data.data
                ? data.data.validateLink
                : { err: 'validateLink failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getAllOrganizations(active: number) {
        try {
            let data = await this._instance.query<{ Organizations: Array<any> }>({
                query: gql`
                    query Organizations($active: Int) {
                        Organizations(active: $active) {
                            organizationid
                            name
                            rosterid
                            isprimary
                            primaryorganizationid
                            enableprivacy
                        }
                    }
                `,
                variables: {
                    active,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('getOrganizations');
            return data.data
                ? data.data.Organizations
                : { err: 'getting organizations failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getOrgsWithCounts(active: any) {
        try {
            let data = await this._instance.query<{ customersWithCounts: any }>({
                query: gql`
                    query customersWithCounts($active: Int) {
                        customersWithCounts(active: $active) {
                            organizationid
                            primaryorganizationid
                            name
                            totalAthletes
                            totalBaselines
                            totalTests
                            active
                            enableprivacy
                        }
                    }
                `,
                variables: {
                    active,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('orgsWithCounts', data.data);
            return data.data
                ? data.data.customersWithCounts
                : { err: 'getting orgs failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getSuborgsWithCounts(active: any, orgid: any) {
        try {
            let data = await this._instance.query<{ suborgsWithCounts: any }>({
                query: gql`
                    query suborgsWithCounts($active: Int, $orgid: String) {
                        suborgsWithCounts(active: $active, orgid: $orgid) {
                            organizationid
                            primaryorganizationid
                            name
                            primaryorgname
                            totalAthletes
                            totalBaselines
                            totalTests
                            active
                            isprimary
                        }
                    }
                `,
                variables: {
                    active,
                    orgid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('suborgsWithCounts', data.data);
            return data.data
                ? data.data.suborgsWithCounts
                : { err: 'getting customers failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getDashboardCounts(organizationid: any) {
        try {
            let data = await this._instance.query<{ getDashboardCounts: any }>({
                query: gql`
                    query getDashboardCounts($organizationid: String!) {
                        getDashboardCounts(organizationid: $organizationid) {
                            organizationid
                            name
                            totalAthletes
                            totalBaselinePending
                            totalImpairedTests
                            totalBaselines
                            totalTests
                            totalBaselinesThisWeek
                            rosterid
                            isprimary
                        }
                    }
                `,
                variables: {
                    organizationid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('getDashboardCounts');
            return data.data
                ? data.data.getDashboardCounts
                : { err: 'getting organization failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getEmployees(active: any) {
        try {
            let data = await this._instance.query<{ employees: Array<any> }>({
                query: gql`
                    query employees($active: Int!) {
                        employees(active: $active) {
                            uid
                            username
                            firstname
                            lastname
                            email
                            roleid
                            active
                            setup
                            signin
                        }
                    }
                `,
                variables: {
                    active,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('employees');
            return data.data
                ? data.data.employees
                : { err: 'getting employees failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async focuslogs(type: number, input: any) {
        try {
            let data = await this._instance.query<{ focuslogs: Array<any> }>({
                query: gql`
                    query focuslogs($type: Int!, $input: LogCriteria) {
                        focuslogs(type: $type, input: $input) {
                            logtimestamp
                            username
                            host
                            event
                        }
                    }
                `,
                variables: {
                    type,
                    input,
                },
                fetchPolicy: 'no-cache',
            });
            console.log(data);
            return data.data
                ? data.data.focuslogs
                : { err: 'getting focuslogs failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getPrimaryOrganizations(active: number) {
        try {
            let data = await this._instance.query<{ primaryOrganizations: Array<any> }>({
                query: gql`
                    query primaryOrganizations($active: Int) {
                        primaryOrganizations(active: $active) {
                            organizationid
                            name
                            contactfirstname
                            contactlastname
                            jobtitle
                            contactphone
                            contactemail
                            address
                            country
                            state
                            city
                            pincode
                            email
                            website
                            isprimary
                            rosterid
                            active
                        }
                    }
                `,
                variables: {
                    active,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('primaryOrganizations');
            return data.data
                ? data.data.primaryOrganizations
                : { err: 'getting primary Organizations failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async addCustomer(organization: any, user: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation addCustomer($organization: OrganizationInput!, $user: UserInput!) {
                        addCustomer(organization: $organization, user: $user) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    organization,
                    user,
                },
            });
            return data.data
                ? data.data.addCustomer
                : { err: 'addCustomer failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getUserShares(uid: string) {
        try {
            let data = await this._instance.query<{ userShares: Array<any> }>({
                query: gql`
                    query userShares($uid: String) {
                        userShares(uid: $uid) {
                            shareid
                            username
                            organization
                            time
                            returntoactivity
                            totalTests
                            totalSharees
                        }
                    }
                `,
                variables: {
                    uid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.userShares
                : { err: 'userShares failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getExternalUsers(shareid: string) {
        try {
            let data = await this._instance.query<{ externalUsers: Array<any> }>({
                query: gql`
                    query externalUsers($shareid: String) {
                        externalUsers(shareid: $shareid) {
                            id
                            firstname
                            lastname
                            email
                            viewstatus
                            time
                            active
                            shareid
                        }
                    }
                `,
                variables: {
                    shareid,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.externalUsers
                : { err: 'externalUsers failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async updateExternalUser(shareuserid: any, shareid: any, active: any, input: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation updateShareUser(
                        $shareuserid: String!
                        $shareid: String!
                        $active: Int!
                        $input: ShareUserInput
                    ) {
                        updateShareUser(
                            shareuserid: $shareuserid
                            shareid: $shareid
                            active: $active
                            input: $input
                        ) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    shareuserid,
                    shareid,
                    active,
                    input,
                },
            });
            return data.data
                ? data.data.updateShareUser
                : { err: 'updateShareUser failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async changePassword(input: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation changePassword($input: PasswordInput!) {
                        changePassword(input: $input) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    input,
                },
            });
            return data.data
                ? data.data.changePassword
                : { err: 'changePassword failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async changePasswordWithToken(input: any, requestToken: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation changePassword($input: PasswordInput!, $requestToken: String) {
                        changePassword(input: $input, requestToken: $requestToken) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    input,
                    requestToken,
                },
            });
            return data.data
                ? data.data.changePassword
                : { err: 'changePasswordWithToken failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async sendUsernames(email: string) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation sendUsernames($email: String) {
                        sendUsernames(email: $email) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    email,
                },
            });
            return data.data
                ? data.data.sendUsernames
                : { err: 'sendUsernames failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async forgotPassword(username: string, email: string) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation forgotPassword($username: String, $email: String) {
                        forgotPassword(username: $username, email: $email) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    username,
                    email,
                },
            });
            return data.data
                ? data.data.forgotPassword
                : { err: 'forgotPassword failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async getCommunityBaseline() {
        try {
            let data = await this._instance.query<{ communityBaseline: any }>({
                query: gql`
                    query communityBaseline {
                        communityBaseline {
                            testid
                            playerid
                            testtimestamp
                            baseline
                            concussed
                            score
                            scoringversion
                            range
                            athlete {
                                firstname
                                lastname
                                organizationname
                                rosterid
                                playerinfo {
                                    playerinfoname
                                    playerinfovalue
                                }
                            }
                            err
                            testcoords {
                                testcoordid
                                testid
                                testcoordtimestamp
                                eye_x
                                eye_y
                            }
                            calibaratedtestcoords {
                                eye_x
                                eye_y
                            }
                            testinfo {
                                testinfoname
                                testinfovalue
                            }
                        }
                    }
                `,
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.communityBaseline
                : { err: 'getting community baseline coords failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async updateAccount(input: any) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation updateAccount($input: UserInput!) {
                        updateAccount(input: $input) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    input,
                },
            });
            return data.data
                ? data.data.updateAccount
                : { err: 'updateAccount failed, response not received' };
        } catch (ex) {
            console.log('errorrro', typeof ex);
            return this.handlException(ex);
        }
    }

    public async getTestList(input: any) {
        try {
            let data = await this._instance.query<{ getTestList: any }>({
                query: gql`
                    query getTestList($input: TestListInput) {
                        getTestList(input: $input) {
                            status
                            message
                            tests {
                                testid
                                playerid
                                testtimestamp
                                baseline
                                concussed
                                score
                                range
                                testtag
                                athlete {
                                    firstname
                                    lastname
                                    organizationname
                                    playerinfo {
                                        playerinfoname
                                        playerinfovalue
                                    }
                                }
                                admin {
                                    firstname
                                    lastname
                                }
                                organization {
                                    name
                                    state
                                    city
                                    contactemail
                                }
                            }
                            total
                        }
                    }
                `,
                variables: {
                    input,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.getTestList
                : { err: 'getting tests failed, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    public async getFailedTestList(input: any) {
        try {
            let data = await this._instance.query<{ getFailedTestList: any }>({
                query: gql`
                    query getFailedTestList($input: FailedTestListInput) {
                        getFailedTestList(input: $input) {
                            status
                            message
                            tests {
                                testid
                                playerid
                                testtimestamp
                                baseline
                                concussed
                                score
                                range
                                testtag
                                athlete {
                                    firstname
                                    lastname
                                    organizationname
                                    playerinfo {
                                        playerinfoname
                                        playerinfovalue
                                    }
                                }
                                user {
                                    firstname
                                    lastname
                                    username
                                }
                                organization {
                                    name
                                    state
                                    city
                                    contactemail
                                }
                            }
                            total
                        }
                    }
                `,
                variables: {
                    input,
                },
                fetchPolicy: 'no-cache',
            });
            return data.data
                ? data.data.getFailedTestList
                : { err: 'getting failed tests errored, response not received' };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    private handlException(ex: any) {
        if (ex.graphQLErrors !== undefined && ex.graphQLErrors.length > 0) {
            let error: any = ex.graphQLErrors[0];
            let ERRORS = Constants.getErrorText();
            if (error.message === ERRORS.ERROR_AUTH) {
                return this.handleAuthExpiration();
            } else if (error.message === ERRORS.ERROR_ACTIVE) {
                return this.handleNoActiveOrg();
            } else if (error.message === ERRORS.ERROR_INVALID_TEST) {
                return this.handleInvalidTestAccess();
            } else if (error.message === ERRORS.ERROR_NOT_FOUND) {
                return { status: 0, message: error.message };
            } else if (error.message === ERRORS.ERROR_UNAUTHORISED) {
                return { status: 404, message: ERRORS.ERROR_UNAUTHORISED_TXT };
            }
        } else if (ex.networkError !== undefined) {
            console.log('network error', ex.networkError);
            return [];
        }
        return [];
    }

    private handleAuthExpiration() {
        console.log('handleAuthExpiration');
        if (storage.getUser() !== LOGGEDINUSERTYPE.ExternalUser.toString()) {
            window.location.href = '/login';
        } else {
            window.location.href =
                '/external/login/' + storage.getSharedUserId() + '/' + storage.getSharedId();
        }
        return [];
    }

    private handleNoActiveOrg() {
        console.log('handleNoActiveOrg');
        return [];
    }

    private handleInvalidTestAccess() {
        window.location.href = '/login';
    }
}



// WEBPACK FOOTER //
// ./src/service/apolloclient.service.ts